export default "__VITE_ASSET__D6PnD7u0__"